import { useEditOrderInfo } from '@@partner:graphql/mutation/order/editOrderInfo.gql'
import { commonFieldChange } from '@@partner:helpers/util'
import { DeliveryType, OrderInfo } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { ShopsPicker } from '@components/common/pickers'
import SelectSlotPicker from '@components/common/commonFormInput/SelectSlotPicker'
import React, { useState } from 'react'
import { Button, ButtonGroup, Form, SelectPicker } from 'rsuite'

type State = {
  shop_id: GQL_ID
  delivery_type: DeliveryType
  slot_id?: GQL_ID
}

type props = {
  order: OrderInfo
  onCancel: () => void
  onSave: () => void
}

export default function EditDeliverySettings ({
  order,
  onCancel,
  onSave
}: props) {
  const [ addressState, setAddressState ] = useState<State>({
    shop_id: order.shop_id,
    delivery_type: order.deliveryType,
    slot_id: order.slot_id,
  })

  const [ saveOrder, { data, loading, error } ] = useEditOrderInfo()

  const handleSaveOrder = async () => {
    try {
      await saveOrder({
        variables: {
          order_id: order.id,
          newData: {
            shop_id: addressState.shop_id,
            slot_id: addressState.slot_id,
            delivery_type: addressState.delivery_type
          }
        }
      })
      onSave()
    }
    catch (e) {
      
    }
  }

  const handleAddressChange = commonFieldChange(setAddressState)

  
  return (
    <Form>
      <div className="ViewOrder__Info__Row">
        <Form.Group className='ViewOrder__Info__Row'>
          <Form.ControlLabel>Тип доставки</Form.ControlLabel>
          <SelectPicker
            value={addressState.delivery_type}
            data={[
              {
                label: 'Слот',
                value: 'slot'
              },
              {
                label: 'Экспресс',
                value: 'express'
              },

              {
                label: 'Самовывоз',
                value: 'pickup'
              }
            ]}
            onChange={handleAddressChange('delivery_type')}
            searchable={false}
            placeholder='Тип доставки'
            valueKey='value'
            labelKey='label'
            cleanable={false}
          />
        </Form.Group>
      </div>
      { [ 'slot', 'pickup' ].includes(addressState.delivery_type) ? (
        <SelectSlotPicker 
          className='ViewOrder__Info__Row'
          zone_id={order.zone_id}
          shop_id={order.shop_id}
          value={addressState.slot_id}
          onChange={handleAddressChange('slot_id')}
        />
      ) : (
        <></>
      )}
      <ShopsPicker
        value={addressState.shop_id}
        onChange={handleAddressChange('shop_id')}
        searchable
      />
      <Button 
        color='green'
        appearance='ghost'
        className='mx-2'
        onClick={handleSaveOrder}
      >
        Сохранить
      </Button>
      <Button 
        appearance='ghost'
        className='mx-2'
        onClick={onCancel}
      >
        Отменить
      </Button>
    </Form>
  )
}